<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">Copyright {{ today | date:'y'}} © Cleveric Solutions V12.01.24 11:53 </p>
    </div>
  </div>
</div>  